import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { FormattedMessage } from 'react-intl';
import DetailWrapper from '../../CardRow/DetailWrapper';
import ButtonWrapper from '../../Button/ButtonWrapper';
import DefaultButton from '../../Button/DefaultButton';
import TabPanel from '../../TabPanel/TabPanel';
import { useForm } from 'react-hook-form';
import PurchaseStep from './PurchaseStep';
import CustomSnackBar from '../../CustomizedComponents/CustomSnackbar';
import { useIntl } from 'react-intl';

const PurchaseStepWrapper = ({
  purschaseStepEle,
  purschaseStepGas,
  handlers,
  setEditable,
  editable,
  loaders,
  errors,
}) => {
  const intl = useIntl();
  const [value, setValue] = useState(0);
  const electric = 'app.configuration.electric';
  const gas = 'app.configuration.gas';
  const cancel = 'app.buttons.cancel';
  const save = 'app.buttons.save';
  const { handleSubmit } = useForm();
  const success = intl.formatMessage({ id: 'app.action.saved' });
  const [message, setMessage] = useState(success);
  const [open, setOpen] = useState(false);
  const [issues, setIssues] = useState(null);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const {
    postLoadingPurchase,
  } = loaders;

  const {
    postErrorPurchase,
  } = errors;


  const {
    setPurschaseStepEle,
    sendHandlerPurchase,
    setPurschaseStepGas,
  } = handlers;

  const handleSend = (idButton, type) => {
    setEditable(!editable);
    if (idButton !== 'cancel') {
      sendHandlerPurchase(type);
      setOpen(true);
    }
  };

  useEffect(() => {
    if (postErrorPurchase) {
      setMessage(postErrorPurchase?.data?.message);
      setIssues(postErrorPurchase?.data?.issues);
    } else {
      setMessage(success);
      setIssues(null);
    }
  }, [success, postErrorPurchase]);


  return (
    <>
      <DetailWrapper>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
        >
          <Tab label={<FormattedMessage id={electric} />} />
          <Tab label={<FormattedMessage id={gas} />} />
        </Tabs>
        <form onSubmit={handleSubmit(handleSend)}>
          <TabPanelField
            purschaseStep={purschaseStepEle}
            value={value}
            editable={editable}
            handler={setPurschaseStepEle}
            index={0}
            handleSend={handleSend}
            cancelTitle={cancel}
            saveTitle={save}
            commodity={'ELE'}
            loaders={loaders}
          />
        </form>
        <form onSubmit={handleSubmit}>
          <TabPanelField
            purschaseStep={purschaseStepGas}
            value={value}
            editable={editable}
            handler={setPurschaseStepGas}
            index={1}
            handleSend={handleSend}
            cancelTitle={cancel}
            saveTitle={save}
            commodity={'GAS'}
            loaders={loaders}
          />
        </form>
        {!postLoadingPurchase && message &&
        <CustomSnackBar
          status={!postErrorPurchase ? 'success' : 'error'}
          message={message}
          setOpen={setOpen}
          open={open}
        />
        }
        {!postErrorPurchase && issues &&
        issues.map((issue) =>(
          <CustomSnackBar
            key={issue}
            status={'error'}
            message={issue}
            setOpen={setOpen}
            open={open}
          />
        ))
        }
      </DetailWrapper>
    </>

  );
};

PurchaseStepWrapper.propTypes = {
  purschaseStepEle: PropTypes.any,
  purschaseStepGas: PropTypes.any,
  handlers: PropTypes.object,
  editable: PropTypes.bool,
  setEditable: PropTypes.func,
  loaders: PropTypes.object,
  errors: PropTypes.object,
};

export default PurchaseStepWrapper;


const TabPanelField = ({
  purschaseStep,
  value,
  editable,
  handler,
  index,
  handleSend,
  cancelTitle,
  saveTitle,
  commodity,
  loaders,
}) => {
  const {
    postLoadingPurchase,
  } = loaders;
  return (
    <TabPanel value={value} index={index}>
      <PurchaseStep
        purschaseStep={purschaseStep}
        handler = {handler}
        editable={editable}
      />
      <ButtonWrapper>
        <DefaultButton
          id={'cancel'}
          primary={false}
          disabled={!editable}
          title={cancelTitle}
          onClick={(event) => {
            handleSend(event.currentTarget.id);
          }}
        />
        <DefaultButton
          primary={true}
          disabled={!editable}
          type="submit"
          onClick={(event) => {
            handleSend(event.currentTarget.id, commodity);
          }}
          title={saveTitle}
          loaders={[postLoadingPurchase]}
        />
      </ButtonWrapper>
    </TabPanel>
  );
};

TabPanelField.propTypes = {
  purschaseStep: PropTypes.any,
  value: PropTypes.any,
  editable: PropTypes.bool,
  handler: PropTypes.func,
  index: PropTypes.any,
  handleSend: PropTypes.func,
  cancelTitle: PropTypes.string,
  saveTitle: PropTypes.string,
  commodity: PropTypes.string,
  loaders: PropTypes.object,
};
